import React, { ReactNode, useCallback, useMemo } from 'react'
import 'devextreme/dist/css/dx.light.css'
import DataGridDevExtreme, {
  // Column,
  // Paging,
  // Pager,
  IDataGridOptions
} from 'devextreme-react/data-grid'
import ptDictionary from './pt.json'
import { locale, loadMessages } from 'devextreme/localization'
// import { PaginationModel } from 'domain/entities/pagination-model'
// import arrayData from './mockData'
import * as S from './styles'
import { ColumnChooser } from 'devextreme/common/grids'

type DataGridProps = {
  ref: any
  children?: ReactNode | ReactNode[]
} & IDataGridOptions

const DataGrid = ({ children, ...props }: DataGridProps, ref: any) => {
  locale('pt')
  loadMessages(ptDictionary)

  // Replace Props with Child Components in the future
  const columnChooserOptions = useMemo(
    () =>
      props.columnChooser ??
      ({
        enabled: false,
        title: 'Colunas',
        mode: 'dragAndDrop',
        width: 250,
        height: 350,
        allowSearch: false,
        emptyPanelText: 'Arraste uma coluna para escondê-la'
      } as ColumnChooser),
    []
  )

  const headerFilterOptions = useMemo(
    () =>
      props.headerFilter ?? {
        visible: true,
        allowSearch: true,
        texts: {
          cancel: 'Cancelar'
        }
      },
    []
  )

  const filterRowOptions = useMemo(
    () => props.filterRow ?? { visible: false },
    []
  )

  const rowAlternationEnabledOption = useMemo(
    () => props.rowAlternationEnabled ?? true,
    []
  )

  const onRowClickOption = useCallback(
    (e) => !!props.onRowClick && props.onRowClick(e),
    []
  )

  const onCellClickOption = useCallback(
    (e) => !!props.onCellClick && props.onCellClick(e),
    []
  )

  const scrollingOptions = useMemo(() => props.scrolling ?? {}, [])

  return (
    <S.Wrapper style={props.style}>
      <DataGridDevExtreme
        ref={ref}
        accessKey={props.accessKey}
        keyExpr={props.keyExpr}
        dataSource={props.dataSource}
        height={props.height ?? '100%'}
        noDataText={props.noDataText ?? 'Nenhum registro para ser exibido'}
        showBorders={props.showBorders ?? true}
        showRowLines={props.showRowLines ?? false}
        showColumnLines={props.showColumnLines ?? true}
        rowAlternationEnabled={rowAlternationEnabledOption}
        columnAutoWidth={props.columnAutoWidth ?? true}
        allowColumnReordering={props.allowColumnReordering ?? false}
        allowColumnResizing={props.allowColumnResizing ?? false}
        columnChooser={columnChooserOptions}
        headerFilter={headerFilterOptions}
        filterRow={filterRowOptions}
        sorting={props.sorting ?? { mode: 'none' }}
        scrolling={scrollingOptions}
        // ////////////////////////////////////////////////////
        // searchPanel={
        //   props.searchPanel ?? {
        //     visible: false,
        //     width: 600,
        //     placeholder: 'Buscar'
        //   }
        // }
        // selection={
        //   props.selection ?? {
        //     showCheckBoxesMode: 'onLongTap',
        //     mode: 'multiple',
        //     allowSelectAll: true,
        //     selectAllMode: 'page'
        //   }
        // }
        // columns={props.columns}
        onCellClick={onCellClickOption}
        onRowClick={onRowClickOption}
      >
        {children}
        {/* <Paging enabled={true} defaultPageSize={10} defaultPageIndex={0} />
          <Pager
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
            infoText="Página {0} de {1} ({2} itens)"
          /> */}
      </DataGridDevExtreme>
    </S.Wrapper>
  )
}

const FowardRefDataGridComponent = React.forwardRef(DataGrid)
export default React.memo(FowardRefDataGridComponent)

FowardRefDataGridComponent.displayName = 'DataGridDevExtreme'
